import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useTabelaHorariosOutletContext } from 'pages/TabelaHorario'
import { useParams } from 'react-router-dom'
import { tabelaHorarios } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirTabelaHorarios() {
    const { id } = useParams()
    const { data } = useTabelaHorariosOutletContext()
    const t = data.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = tabelaHorarios.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!t) return null

    const handleSubmit = () =>
        mutateAsync(t.id, {
            onSuccess: () => {
                toast.success('Tabela excluída com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'TabelaDeHorários'])}
        >
            <Dialog.Content>
                Realmente deseja excluir a tabela {t.nome}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
